import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  value: number;
  max: number;
  label?: string;
  showValue?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}
export function ProgressBar({
  value,
  max,
  label,
  showValue = true,
  size = 'md',
  className = ''
}: ProgressBarProps) {
  const percentage = Math.min(value / max * 100, 100);
  const heights: Record<string, string> = {
    sm: 'h-1.5',
    md: 'h-2.5'
  };
  return <div className={className} data-id="element-618">
      {(label || showValue) && <div className="flex items-center justify-between mb-1.5" data-id="element-619">
          {label && <span className="text-sm text-[#B0B0B0]" data-id="element-620">{label}</span>}
          {showValue && <span className="text-sm font-medium text-[#C8A84E]" data-id="element-621">
              {Math.round(percentage)}%
            </span>}
        </div>}
      <div className={`w-full bg-[#2A2A2A] rounded-full overflow-hidden ${heights[size]}`} data-id="element-622">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className={`${heights[size]} rounded-full bg-gradient-to-r from-[#C8A84E] to-[#D4B85A]`} data-id="element-623" />
      </div>
    </div>;
}